export default "__VITE_ASSET__DWNXqkeJ__"